import dynamic from "next/dynamic";

export const DynamicContent045 = dynamic(() => import("./Content045"), {
  suspense: true,
});
